import { Alert, Box } from "@mui/material";
import FilterableSkuList, {
  SkuListColumn,
  SkuListFilter,
} from "components/FilterableSkuList";
import Loader from "components/Loader";
import RedirectBackButton from "components/RedirectBackButton";
import useGlobalContext from "hooks/globalData";
import useTitle from "hooks/useTitle";
import { FormattedMessage as T, useIntl } from "react-intl";
import { useQuery } from "react-query";
import { Navigate, useParams } from "react-router-dom";
import contextStore from "stores/contextStore";

export const ResourceSkus = () => {
  const { formatMessage: t } = useIntl();
  const { id } = useParams<{ id: string }>();
  const { resourceService, resourceDetailsUrl } = useGlobalContext();
  const { organizationId } = contextStore.useState();

  const resourceResult = useQuery(
    ["resource", id],
    () => resourceService.getResource(id!),
    {
      enabled: !!id,
    }
  );

  const resource = resourceResult.data?.data;
  useTitle(
    t(
      { id: "associatedSkusTitle" },
      { name: resource?.name || t({ id: "user" }) }
    )
  );

  if (!id) return <Navigate to={resourceDetailsUrl(id)} replace />;
  if (resourceResult.isLoading) return <Loader />;
  if (resourceResult.isError) {
    return (
      <Box mt={4}>
        <Alert severity="error">
          <T id="resourceLoadError" />
        </Alert>
      </Box>
    );
  }

  return (
    <>
      <RedirectBackButton
        redirectRoute={resourceDetailsUrl(id)}
        labelKey="backToDetailsButtonLabel"
      />
      <h1>
        <u>
          <T id="associatedSkus" />
        </u>
        : {resource?.name}
      </h1>
      <FilterableSkuList
        organizationId={organizationId}
        lazyTableTitle="associatedSkus"
        resourceId={id}
        columns={[
          SkuListColumn.Sku,
          SkuListColumn.Title,
          SkuListColumn.SkuFormat,
          SkuListColumn.SkuAvailability,
          SkuListColumn.Status,
          SkuListColumn.SkuResourceActions,
        ]}
        filters={[
          SkuListFilter.Search,
          SkuListFilter.Dates,
          SkuListFilter.SkuFormat,
          SkuListFilter.SkuAvailability,
          SkuListFilter.SkuStatus,
        ]}
      />
    </>
  );
};
